module.exports = __webpack_public_path__ + "c0adcefa0a15968c289b6b8caf62bcba.svg";